import React from 'react'
import { Route, Switch } from 'react-router-dom'

import RuleList from './RuleList'
import RuleAdd from './RuleAdd'
import RuleEdit from './RuleEdit'
import RuleChangeList from './RuleChangeList'

const TecDocBrandRules = () => ({
    routes: [
        {
            path: '/tecdoc-brand-rules',
            render: ({ match }) => (
                <Switch>
                    <Route path={match.url} exact component={RuleList} />
                    <Route path={`${match.url}/add`} exact component={RuleAdd} />
                    <Route path={`${match.url}/:ruleId`} exact component={RuleEdit} />
                </Switch>
            ),
        },
        {
            path: '/tecdoc-rule-changes',
            render: ({ match }) => (
                <Switch>
                    <Route path={match.url} exact component={RuleChangeList} />
                </Switch>
            ),
        },
    ],
})

export default TecDocBrandRules
